export const PUBLIC_AUTH_ROUTES = new Set([
  "/",
  "/two-factor-auth",
  "/forgot-password",
  "/reset-password",
  "/first-verify",
  "/email-verification",
]);

export const SEARCH_BUTTON_ID = "my-leads-search-button";
export const SEARCH_MODAL_ID = "search-patient-modal-page";
export const SEARCH_INPUT_ID = "search-patient-input";

export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  return target.isContentEditable;
}

export function isSearchModalOpen(): boolean {
  return Boolean(document.getElementById(SEARCH_MODAL_ID));
}

export function isOtherModalOpen(): boolean {
  const dialogs = document.querySelectorAll('[role="dialog"]');
  for (let i = 0; i < dialogs.length; i++) {
    const dialog = dialogs[i];
    if (dialog.id !== SEARCH_MODAL_ID) {
      return true;
    }
  }
  return false;
}

export function isUniversalSearchShortcutKey(event: KeyboardEvent): boolean {
  const modKey = event.metaKey || event.ctrlKey;
  if (!modKey || !event.key) return false;
  return event.key === "/";
}

export function shouldOpenSearchFromShortcut(options: {
  isAuthenticated: boolean;
  pathname: string;
  event: KeyboardEvent;
}): boolean {
  const { isAuthenticated, pathname, event } = options;

  if (!isAuthenticated) return false;
  if (PUBLIC_AUTH_ROUTES.has(pathname)) return false;
  if (!isUniversalSearchShortcutKey(event)) return false;
  if (isOtherModalOpen()) return false;

  if (isEditableTarget(event.target) && !isSearchModalOpen()) {
    return false;
  }

  return true;
}

export function shouldRefocusSearchInputFromShortcut(options: {
  isAuthenticated: boolean;
  pathname: string;
  event: KeyboardEvent;
}): boolean {
  const { isAuthenticated, pathname, event } = options;

  if (!isAuthenticated) return false;
  if (PUBLIC_AUTH_ROUTES.has(pathname)) return false;
  if (!isUniversalSearchShortcutKey(event)) return false;
  if (isOtherModalOpen()) return false;
  if (!isSearchModalOpen()) return false;
  if (!isEditableTarget(event.target)) return false;

  const target = event.target;
  if (target instanceof HTMLElement && target.id === SEARCH_INPUT_ID) {
    return false;
  }

  return true;
}

export function openSearchViaHeaderButton(): void {
  document.getElementById(SEARCH_BUTTON_ID)?.click();
}

export function isMacPlatform(): boolean {
  if (typeof navigator === "undefined") return false;
  const nav = navigator as Navigator & {
    userAgentData?: { platform?: string };
  };
  const platform = nav.userAgentData?.platform ?? navigator.platform ?? "";
  return /Mac|iPhone|iPad|iPod/i.test(platform);
}

export function getUniversalSearchShortcutModifier(): "⌘" | "Ctrl" {
  return isMacPlatform() ? "⌘" : "Ctrl";
}

export function getUniversalSearchShortcutLabel(): string {
  const mod = getUniversalSearchShortcutModifier();
  return `${mod}+/`;
}
